<template>
  <div>
    <v-card class="elevation-0">
      <v-card-text>
        <v-row align="center">
          <div cols="12">
            <span class="font-weight-black"> Groupe : </span
            >{{ ParcoursEffectifs[0].nom_groupe }}
          </div>
        </v-row>
        <v-row align="center">
          <v-col cols="6">
            <div>
              <span class="font-weight-black">Région :</span>
              {{ ParcoursEffectifs[0].ll_region }}
            </div>
            <div>
              <span class="font-weight-black">District :</span>
              {{ ParcoursEffectifs[0].ll_district }}
            </div>
            <div>
              <span class="font-weight-black">Commune : </span
              >{{ ParcoursEffectifs[0].ll_commune }}
            </div>
            <div>
              <span class="font-weight-black">Fokontany :</span>
              {{ ParcoursEffectifs[0].ll_fokontany }}
            </div>
            <div>
              <span class="font-weight-black">Village :</span>
              {{ ParcoursEffectifs[0].village }}
            </div>
          </v-col>
          <v-col cols="6">
            <div>
              <span class="font-weight-black">Bailleur :</span>
              {{ ParcoursEffectifs[0].ll_bailleur }}
            </div>

            <div>
              <span class="font-weight-black">Thème :</span>
              {{ ParcoursEffectifs[0].ll_theme }}
            </div>

            <div>
              <span class="font-weight-black">Projet :</span>
              {{ ParcoursEffectifs[0].ll_programme }}
            </div>
            <div>
              <span class="font-weight-black">Campagne : </span
              >{{ ParcoursEffectifs[0].ll_parcours_effectif }}
            </div>
            <div>
              <span class="font-weight-black">Mois :</span>
              {{ ParcoursEffectifs[0].ll_mois }}
            </div>
            <!-- <div>
              <span class="font-weight-black">Mois Unix :</span>
              {{ ParcoursEffectifs[0].yahoo }}
            </div> -->
          </v-col>
        </v-row>

        <v-row align="center">
          <div cols="12">
            <span class="font-weight-black">Animateur :</span>
            {{ ParcoursEffectifs[0].nom_responsable }}
          </div>
        </v-row>
        <!--  {{ ParcoursEffectifs[0]}} -->
      </v-card-text>
    </v-card>
    <v-card class="blue">
      <v-card-title primary-title>
        Données totales Saisi par Animateur (non modifiable par opérateur de
        saisie directement)
      </v-card-title>

      <v-card-text>
        <v-card
          class="elevation-1 ma-2 rounded blue-grey lighten-5"
          v-for="(detailEtape, index) in detailEtapes"
          :key="index"
        >
          <v-card-title primary-title>
            {{ detailEtape.ll_details_etapes }}
          </v-card-title>
          <v-card-text>
            <div v-if="detailEtape.type_champ == 0">
              <!-- {{ detailEtape.rangDetailEtape }} -->
              <!--  {{ detailEtape.typeChamp }} -->

              <v-form
                ref="formValid"
                lazy-validation
                @submit.prevent="sauvegarder(detailEtape, index)"
              >
                <v-simple-table>
                  <thead>
                    <tr>
                      <td>
                        Nombre de Femmes
                      </td>
                      <td>
                        Nombre d'Hommes
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="elevation-1 ma-2 rounded">
                      <td>
                        <v-text-field
                          :disabled="disabled"
                          outlined
                          type="text"
                          v-model="detailEtape.valueRecapFemmes"
                          :rules="isChiffre"
                        ></v-text-field>
                      </td>
                      <td>
                        <v-text-field
                          :disabled="disabled"
                          outlined
                          type="text"
                          :rules="isChiffre"
                          v-model="detailEtape.valueRecapHommes"
                        ></v-text-field>
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
                <v-btn
                  v-if="user.role === 'superviseur'"
                  rounded
                  class="ma-2"
                  color="success"
                  type="submit"
                >
                  <v-icon>mdi-content-save-all</v-icon> Sauvegarder</v-btn
                >
              </v-form>
            </div>

            <div v-else-if="detailEtape.type_champ == 1">
              {{ detailEtape.ll_details_etapes }}
              <!-- {{ detailEtape.rangDetailEtape }} -->
              <!--  {{ detailEtape.typeChamp }} -->
              <v-form
                ref="formValid"
                lazy-validation
                @submit.prevent="sauvegarder(detailEtape, index)"
              >
                <v-simple-table>
                  <tbody>
                    <tr class="elevation-1 ma-2 rounded blue-grey lighten-5">
                      <td>
                        <v-text-field
                          :disabled="disabled"
                          outlined
                          :label="detailEtape.ll_details_etapes"
                          type="text"
                          v-model="detailEtape.valueCalcul"
                          :rules="isChiffre"
                        ></v-text-field>
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
                <v-btn
                  v-if="user.role === 'superviseur'"
                  type="submit"
                  rounded
                  color="success"
                  >Sauvegarder</v-btn
                >
              </v-form>
            </div>
            <div v-else-if="detailEtape.type_champ == 2">
              {{ detailEtape.ll_details_etapes }} - Nombre de membres ayant
              bénéficié<!-- 
        {{ detailEtape.rangDetailEtape }} 
              {{ detailEtape.typeChamp }} -->
              <!--  Alphanumérique -->
              <v-form
                ref="formValid"
                lazy-validation
                @submit.prevent="sauvegarder(detailEtape, index)"
              >
                <v-simple-table>
                  <tbody>
                    <tr class="elevation-1 ma-2 rounded blue-grey lighten-5">
                      <td>
                        <v-text-field
                          :disabled="disabled"
                          outlined
                          type="text"
                          v-model="detailEtape.valueNombreMembre"
                          :rules="isChiffre"
                        ></v-text-field>
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
                <v-btn
                  v-if="user.role === 'superviseur'"
                  rounded
                  color="success"
                  type="submit"
                  >Sauvegarder</v-btn
                >
              </v-form>
            </div>
          </v-card-text>
        </v-card>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  created() {
    if (this.user.role != "superviseur") {
      this.disabled = true;
    }
  },
  components: {
    //fiche: require("@/components/fiche.vue").default,
  },
  data() {
    return {
      parcoursEffectif: "fsdfs",
      //parcoursEffectif : $route.query.parcoursEffectif,
      dialog: false,
      disabled: false,
      isChiffre: [
        //(v) => !!v || "requis",
        (v) =>
          (typeof parseInt(v, 10) === "number" && isFinite(parseInt(v, 10))) ||
          "Chiffre Attendu",
      ],
    };
  },
  props: {
    detailEtapes: { type: Array, required: true },
    etapeEffective: { type: Object, required: true },
  },
  methods: {
    sauvegarder(detailEtape, index) {
      let self = this;
    

      if (self.$refs[`formValid`][index].validate()) {
        var oldLine = self.etapeEffective.recapVerified[index];
        oldLine.valueRecapFemmes = parseInt(detailEtape.valueRecapFemmes, 10);
        oldLine.valueRecapHommes = parseInt(detailEtape.valueRecapHommes, 10);
        oldLine.valueCalcul = detailEtape.valueCalcul;
        oldLine.valueNombreMembre = detailEtape.valueNombreMembre;

        // console.log("recapVerified", self.etapeEffective.recapVerified);
        ///updateRecapVerified to this value in Firebase

        var ref = this.$firebase
          .firestore()
          .collection("etapes_effectives")
          .doc(self.etapeEffective.id);
        ref
          .set(
            {
              recapVerified: self.etapeEffective.recapVerified,
              //start
              date_debut: self.ParcoursEffectifs[0].date_debut,
              date_fin: self.ParcoursEffectifs[0].date_fin,
              ll_mois: self.ParcoursEffectifs[0].ll_mois,
              //end
            },
            { merge: true }
          )
          .then(function () {
            console.log("success", self.etapeEffective.recapVerified);
            let payload = {
              IdParcoursEffectif:
                self.etapeEffective.parcours_effectif_id_parcours_effectif,
              idEtape: self.etapeEffective.etape_id_etape,
            };

            self.get_etape_effective_by_parcours_et_etape(payload);
          })
          .catch(function (error) {
            console.log("error", error);
          });
      } else {
        //self.$refs[`formValid`][index].reset();
        self.$refs[`formValid`][index].resetValidation();
      } 
    },
    ...mapActions({
      get_etape_effective_by_parcours_et_etape:
        "EtapeEffective/get_etape_effective_by_parcours_et_etape",
    }),
  },
  computed: {
    ...mapState({
      user: (state) => state.Auth.user,
      /*    ParcoursEffectifsold: (state) =>
        _.filter(state.ParcoursEffectif.ParcoursEffectif, {
          id: this.$route.query.parcoursEffectif,
        }), */
      ParcoursEffectifs(state) {
        return _.filter(state.ParcoursEffectif.ParcoursEffectif, {
          id: this.$route.query.parcoursEffectif,
        });
      },
    }),
  },
};
</script>

<style lang="scss" scoped></style>
